import { ICellRendererParams } from 'ag-grid-community';
import { StringListCellRenderer } from '../../../../../../components/AgTable/cell-renderers/StringListCellRenderer';
import { FMT } from '../../../../../../util/formatter-service';

interface TemplateNamesCellRendererParams extends ICellRendererParams {
  activeTemplateUuids: Set<string>;
}

export function resolveTemplateDisplayName(uuid: string, activeTemplateUuids: Set<string>): string {
  const name = FMT.format('kpiTemplateName', uuid);
  return activeTemplateUuids.has(uuid) ? name : `${name} (unsupported)`;
}

export function TemplateNamesCellRenderer(params: TemplateNamesCellRendererParams) {
  const templateUuids: string[] = params.value ?? [];
  if (templateUuids.length === 0) {
    return null;
  }
  const names = templateUuids.map((uuid) => resolveTemplateDisplayName(uuid, params.activeTemplateUuids));
  return <StringListCellRenderer {...params} value={names} title='Templates' />;
}
